import { ActionsObservable } from "redux-observable";
import * as firebase from 'firebase/app';
import { Observable } from "rxjs";
import { QuerySnapshot, QueryDocumentSnapshot, DocumentSnapshot, Query } from "@firebase/firestore-types";
import {
  CollectionListenAction,
  CollectionChangeAction,
  DocListenAction,
  DocChangeAction
} from './index';

interface ListenCollectionOption<T> {
  collection: string;
  listenType: string;
  unlistenType: string;
  changeCollection: (data: {
    page?: number,
    docs: T[],
    last?: QueryDocumentSnapshot,
  }) => CollectionChangeAction<T>;
}
export const createListenCollectionEpic = <T extends { id: string }>(opt: ListenCollectionOption<T>) => {
  return (action$: ActionsObservable<CollectionListenAction<T>>) =>
    action$.ofType(opt.listenType)
      .flatMap(({ payload: { startAfter, page } }) => {
        return new Observable<QuerySnapshot>(observer => {
          let query: Query = firebase.firestore()
            .collection(opt.collection);
             // .orderBy('createdOn', 'desc');
          if (startAfter) {
            query = query.startAfter(startAfter);
          }

          if (page) {
            query = query.limit(50);
          }

          return query.onSnapshot(observer);
        }).map(sn => {
          const last = sn.docs[sn.docs.length - 1];
          const docs = sn.docs.map(d => ({ id: d.id, ...d.data() } as T));
          return opt.changeCollection({ page, docs, last });
        }).takeUntil(action$.ofType(opt.unlistenType));
      });
};

interface ListenDocOption<T> {
  collection: string;
  listenType: string;
  unlistenType: string;
  changeDoc: (doc: T) => DocChangeAction<T>;
}

export const createListenDocEpic = <T extends { id: string }>(opt: ListenDocOption<T>) => {
  return (action$: ActionsObservable<DocListenAction>) =>
    action$.ofType(opt.listenType)
      .flatMap(({ payload: { id } }) => {
        return new Observable<DocumentSnapshot>(observer => {
          return firebase.firestore().doc(`${opt.collection}/${id}`).onSnapshot(observer);
        }).filter(sn => sn.exists).map(sn => {
          const doc = sn.data();
          const item = { id, ...doc } as T;
          return opt.changeDoc(item);
        }).takeUntil(action$.ofType(opt.unlistenType));
      });
}


// WEBPACK FOOTER //
// ./src/firebase/epics.ts